import React from 'react';
import { ManagedDropdown } from '../../../../.starryUI/ManagedDropdown/ManagedDropdown';
import { useEntryDirectoryEvents } from '../context/EntryDirectoryContext';
import { Button } from '../../../../.starryUI/grids/buttonBar/Button';
import { Icon, Icons } from '@starrez/starryui';
import { strings } from '../localization';
import { OptionScroller, SelectionOption, Option } from '../../../../.starryUI/lists/SelectionOption';

export const ExportDirectory = () => {
    const { runExport } = useEntryDirectoryEvents();

    return (
        <ManagedDropdown
            placement="bottom-end"
            manager={(onClick, { visible }) => (
                <Button aria-pressed={visible} aria-expanded={visible} ariaLabel="Export Directory" onClick={onClick} title="Export">
                    <Icon Icon={Icons.Export} />
                </Button>
            )}
        >
            {() => (
                <SelectionOption focusFirstElement>
                    <OptionScroller>
                        <Option onClick={() => runExport('Text')} caption={strings.Label_Text} />
                        <Option onClick={() => runExport('CSV')} caption={strings.Label_CSV} />
                        <Option onClick={() => runExport('PDF')} caption={strings.Label_PDF} />
                        <Option onClick={() => runExport('XML')} caption={strings.Label_XML} />
                        <Option onClick={() => runExport('TXT')} caption={strings.Label_FixedWidthText} />
                        <Option onClick={() => runExport('HTML')} caption={strings.Label_Html} />
                    </OptionScroller>
                </SelectionOption>
            )}
        </ManagedDropdown>
    );
};
